module.exports = __webpack_public_path__ + "img/wish-or-will.054b2a30.jpg";